import { create } from 'zustand';
import { handleSelectTemplate } from '../dispatcher-methods/register-page-change';

export const useTemplateSelectStore = create(set => ({
  templateID: '',
  orientation: '',
  shuffle: false,
  layouts: null,
  updateTemplateSelectStore: payload => {
    set(payload);

    const payloadItems = Object.keys(payload);

    if (payloadItems.includes('templateID')) {
      const templateID = payload['templateID'];
      handleSelectTemplate({ templateID });

      if (payloadItems.includes('shuffle')) {
        const shuffle = payload['shuffle'];
        handleSelectTemplate({ templateID, shuffle });
      }
    }
  },
}));
